export const periods = {
  day: {
    alias: 'day',
    label: '{{month}}-{{period}}, {{year}}',
    xLabel: 'Daily',
    timeVariables: [
      {
        type: 'period',
        daysPerPeriod: 1,
        digitCount: 2,
      },
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    firstOccurrence: 1,
    shortName: 'D',
    fullName: 'Day',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    style: '<style>',
  },
  '7day': {
    alias: '7day',
    label: '{{month}}-{{period}}, {{year}}',
    xLabel: 'Weekly',
    timeVariables: [
      {
        type: 'period',
        daysPerPeriod: 7,
        digitCount: 2,
      },
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    firstOccurrence: 'Monday',
    shortName: 'W',
    fullName: 'Week',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    style: '<style>',
  },
  pentad: {
    alias: 'pentad',
    label: '{{month}} Pen-{{period}} {{year}}',
    xLabel: 'Pentadal',
    timeVariables: [
      {
        type: 'period',
        itemsPerMonth: 6,
        digitCount: 2,
      },
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: 'P',
    fullName: 'Pentad',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    style: '<style>',
  },
  pentad_10daycomposite: {
    alias: 'pentad',
    label: '{{month}} Pen-{{period}} {{year}}',
    xLabel: 'Pentadal',
    timeVariables: [
      {
        type: 'period',
        itemsPerMonth: 6,
        digitCount: 2,
      },
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: 'P',
    fullName: 'Pentad',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    style: '<style>',
  },
  dekad: {
    alias: 'dekad',
    label: '{{month}}-{{period}}, {{year}}',
    xLabel: 'Dekadal',
    timeVariables: [
      {
        type: 'period',
        itemsPerMonth: 3,
        digitCount: 2,
      },
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: 'D',
    fullName: 'Dekad',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    style: '<style>',
  },
  month: {
    alias: 'month',
    label: '{{month}} {{year}}',
    xLabel: 'Monthly',
    timeVariables: [
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: '',
    fullName: 'Month',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    style: '<style>',
  },
  '2month': {
    alias: '2month',
    label: '{{month}} {{year}}',
    xLabel: '2 Monthly',
    timeVariables: [
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: '',
    fullName: '2 Month',
    months: ['Jan-Feb', 'Feb-Mar', 'Mar-Apr', 'Apr-May', 'May-Jun', 'Jun-Jul', 'Jul-Aug', 'Aug-Sep', 'Sep-Oct', 'Oct-Nov', 'Nov-Dec', 'Dec-Jan'],
    shortMonths: ['JF', 'FM', 'MA', 'AM', 'MJ', 'JJ', 'JA', 'AS', 'SO', 'ON', 'ND', 'DJ'],
    style: '<style>',
  },
  '3month': {
    alias: '3month',
    label: '{{month}} {{year}}',
    xLabel: '3 Monthly',
    timeVariables: [
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: '',
    fullName: '3 Month',
    months: [
      'Jan-Feb-Mar',
      'Feb-Mar-Apr',
      'Mar-Apr-May',
      'Apr-May-Jun',
      'May-Jun-Jul',
      'Jun-Jul-Aug',
      'Jul-Aug-Sep',
      'Aug-Sep-Oct',
      'Sep-Oct-Nov',
      'Oct-Nov-Dec',
      'Nov-Dec-Jan',
      'Dec-Jan-Feb',
    ],
    shortMonths: ['JFM', 'FMA', 'MAM', 'AMJ', 'MJJ', 'JJA', 'JAS', 'ASO', 'SON', 'OND', 'NDJ', 'DJF'],
    style: '<mm><nn>',
  },
  '4month': {
    alias: '4month',
    label: '{{month}} {{year}}',
    xLabel: '4 Monthly',
    timeVariables: [
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: '',
    fullName: '4 Month',
    months: [
      'Jan-Feb-Mar-Apr',
      'Feb-Mar-Apr-May',
      'Mar-Apr-May-Jun',
      'Apr-May-Jun-Jul',
      'May-Jun-Jul-Aug',
      'Jun-Jul-Aug-Sep',
      'Jul-Aug-Sep-Oct',
      'Aug-Sep-Oct-Nov',
      'Sep-Oct-Nov-Dec',
      'Oct-Nov-Dec-Jan',
      'Nov-Dec-Jan-Feb',
      'Dec-Jan-Feb-Mar',
    ],
    shortMonths: ['JFMA', 'FMAM', 'MAMJ', 'AMJJ', 'MJJA', 'JJAS', 'JASO', 'ASON', 'SOND', 'ONDJ', 'NDJF', 'DJFM'],
    style: '<mm><nn>',
  },
  '5month': {
    alias: '5month',
    label: '{{month}} {{year}}',
    xLabel: '5 Monthly',
    timeVariables: [
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: '',
    fullName: '5 Month',
    months: [
      'Jan-Feb-Mar-Apr-May',
      'Feb-Mar-Apr-May-Jun',
      'Mar-Apr-May-Jun-Jul',
      'Apr-May-Jun-Jul-Aug',
      'May-Jun-Jul-Aug-Sep',
      'Jun-Jul-Aug-Sep-Oct',
      'Jul-Aug-Sep-Oct-Nov',
      'Aug-Sep-Oct-Nov-Dec',
      'Sep-Oct-Nov-Dec-Jan',
      'Oct-Nov-Dec-Jan-Feb',
      'Nov-Dec-Jan-Feb-Mar',
      'Dec-Jan-Feb-Mar-Apr',
    ],
    shortMonths: ['JFMAM', 'FMAMJ', 'MAMJJ', 'AMJJA', 'MJJAS', 'JJASO', 'JASON', 'ASOND', 'SONDJ', 'ONDJF', 'NDJFM', 'DJFMA'],
    style: '<mm><nn>',
  },
  '6month': {
    alias: '6month',
    label: '{{month}} {{year}}',
    xLabel: '6 Monthly',
    timeVariables: [
      {
        type: 'month',
        digitCount: 2,
      },
      {
        type: 'year',
      },
    ],
    shortName: '',
    fullName: '6 Month',
    months: [
      'Jan-Feb-Mar-Apr-May-Jun',
      'Feb-Mar-Apr-May-Jun-Jul',
      'Mar-Apr-May-Jun-Jul-Aug',
      'Apr-May-Jun-Jul-Aug-Sep',
      'May-Jun-Jul-Aug-Sep-Oct',
      'Jun-Jul-Aug-Sep-Oct-Nov',
      'Jul-Aug-Sep-Oct-Nov-Dec',
      'Aug-Sep-Oct-Nov-Dec-Jan',
      'Sep-Oct-Nov-Dec-Jan-Feb',
      'Oct-Nov-Dec-Jan-Feb-Mar',
      'Nov-Dec-Jan-Feb-Mar-Apr',
      'Dec-Jan-Feb-Mar-Apr-May',
    ],
    shortMonths: ['JFMAMJ', 'FMAMJJ', 'MAMJJA', 'AMJJAS', 'MJJASO', 'JJASON', 'JASOND', 'ASONDJ', 'SONDJF', 'ONDJFM', 'NDJFMA', 'DJFMAM'],
    style: '<mm><nn>',
  },
};
